module.exports = __webpack_public_path__ + "static/img/shushiSkill.7ee5374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/shushiSkill.png
// module id = 0mIq
// module chunks = 0